.rowContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.toggleContainer {
    width: 75px;
    padding: 2px;
}

.titleContainer {
    width: 800px;
    padding: 10px;
}

.limitPreferenceContainer {
    display: flex;
    flex: 2 1 auto;
    width: 200px;
    padding: 10px;
}

.overflowContainer {
    padding: .25rem 0rem !important;
}

